import React from 'react';
import { motion } from 'framer-motion';

export const RunTestsIcon: React.FC<{ isActive: boolean }> = ({ isActive }) => {
	return (
		<motion.svg
			animate={isActive ? { scale: 1.15 } : null}
			width="100%"
			height="100%"
			viewBox="0 0 64 65"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect
				x="21.3203"
				y="22.3516"
				width="21.3571"
				height="21.3571"
				rx="1.25"
				stroke="#F27C00"
				stroke-width="1.5"
			/>
			<rect
				x="8.75"
				y="9.78125"
				width="7.64286"
				height="7.64286"
				rx="1.25"
				stroke="#F27C00"
				stroke-width="1.5"
			/>
			<rect
				x="47.6074"
				y="9.78125"
				width="7.64286"
				height="7.64286"
				rx="1.25"
				stroke="#F27C00"
				stroke-width="1.5"
			/>
			<rect
				x="55.25"
				y="56.2812"
				width="7.64286"
				height="7.64286"
				rx="1.25"
				transform="rotate(-180 55.25 56.2812)"
				stroke="#F27C00"
				stroke-width="1.5"
			/>
			<rect
				x="16.3926"
				y="56.2812"
				width="7.64286"
				height="7.64286"
				rx="1.25"
				transform="rotate(-180 16.3926 56.2812)"
				stroke="#F27C00"
				stroke-width="1.5"
			/>
			<circle cx="31.9986" cy="51.317" r="2.28571" fill="#F27C00" />
			<circle cx="13.7134" cy="33.0299" r="2.28571" fill="#F27C00" />
			<path
				d="M16 17.0312L21.7143 22.7455"
				stroke="#F27C00"
				stroke-width="1.5"
			/>
			<path
				d="M42.2852 43.3164L47.9994 49.0307"
				stroke="#F27C00"
				stroke-width="1.5"
			/>
			<path
				d="M16 49.0312L21.7143 43.317"
				stroke="#F27C00"
				stroke-width="1.5"
			/>
			<path
				d="M42.2852 22.7461L47.9994 17.0318"
				stroke="#F27C00"
				stroke-width="1.5"
			/>
			<path d="M32 21.603V15.8887" stroke="#F27C00" stroke-width="1.5" />
			<path d="M32 50.1752V44.4609" stroke="#F27C00" stroke-width="1.5" />
			<path
				d="M14.856 33.0312L20.5703 33.0312"
				stroke="#F27C00"
				stroke-width="1.5"
			/>
			<path
				d="M43.4283 33.0312L49.1426 33.0312"
				stroke="#F27C00"
				stroke-width="1.5"
			/>
			<circle cx="49.1431" cy="33.0299" r="2.28571" fill="#F27C00" />
			<circle cx="31.9986" cy="14.7447" r="2.28571" fill="#F27C00" />
			<path
				d="M27.4277 33.1004L30.2225 35.8952L36.5142 29.6035"
				stroke="#F27C00"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</motion.svg>
	);
};
